<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: 'ThirdPartySecretKey',
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'thirdPartySecretKey:add',
        update: 'thirdPartySecretKey:update',
        delete: 'thirdPartySecretKey:delete',
        deleteBatch: 'thirdPartySecretKey:deleteBatch'
      },
      url: {
        get: '/thirdPartySecretKey/listByCondition',
        add: '/thirdPartySecretKey/add',
        update: '/thirdPartySecretKey/update',
        delete: '/thirdPartySecretKey/delete',
        delete_batch: '/thirdPartySecretKey/deleteBatch',
        status: '/thirdPartySecretKey/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      },
        {
          field: 'agentId',
          label: '代理',
          selectUrl: '/agent/getAll',
          selectData: [],
          show: {
            type: 'select',
          },
        }, {
          field: 'platform',  // 字段名
          label: '密钥平台',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'secretKey',  // 字段名
          label: '密钥',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'keyStatus',  // 字段名
          label: '密钥状态',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
          status: true,
        },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },
          {
            field: 'agentId',
            label: '代理：',
            type: 'select',
            placeholder: '请选择代理',
            rules: [{required: true, message: '请选择代理', trigger: 'blur'}],
            selectUrl: '/agent/getAll',
            selectData: [],
            add: true,
            update: true,
            filterable: true,
          }, {
            field: 'platform',  // 字段名
            label: '密钥平台',  // 字段显示名称
            type: 'input',
            placeholder: '请输入密钥平台',
            rules: [
              {required: true, message: '密钥平台不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'secretKey',  // 字段名
            label: '密钥',  // 字段显示名称
            type: 'input',
            placeholder: '请输入密钥',
            rules: [
              {required: true, message: '密钥不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }
        ]
      },
      operate: []
    }
  }
}
</script>

<style scoped>

</style>
